import { render, staticRenderFns } from "./VariationForm.vue?vue&type=template&id=1fcdc79a&scoped=true"
import script from "./VariationForm.vue?vue&type=script&lang=js"
export * from "./VariationForm.vue?vue&type=script&lang=js"
import style0 from "./VariationForm.vue?vue&type=style&index=0&id=1fcdc79a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcdc79a",
  null
  
)

export default component.exports